"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCollectionModel = exports.IkeObjectCollection = void 0;
const base_1 = require("./base");
class IkeObjectCollection extends base_1.IkeRestObject {
    constructor() {
        super();
        this.className = 'Collection';
        this.actionName = 'collection';
        this.cacheKeys['uuid'] = true;
        this.cacheKeys['revision'] = true;
    }
    updateCache(key, result, rest) {
        super.updateCache(key, result, rest);
        this.cacheIfLatest('uuid', result, rest);
        this.cacheIfLatest('revision', result, rest);
    }
}
exports.IkeObjectCollection = IkeObjectCollection;
exports.IkeObjectCollectionModel = {
    className: 'CollectionModel',
    actionName: 'collection.model',
    canCache(key) {
        return key === 'revision';
    },
};
//# sourceMappingURL=collection.object.js.map